import { c as _c } from "react/compiler-runtime";
import type { NotificationTab } from '@/types/notificationBell/types';
interface Props {
  tab: NotificationTab;
  scoped?: boolean;
}
export function NotificationEmptyState(t0) {
  const $ = _c(3);
  const {
    tab,
    scoped: t1
  } = t0;
  const scoped = t1 === undefined ? false : t1;
  const message = scoped ? "Nenhuma notifica\xE7\xE3o por aqui." : tab === "unread" ? "Tudo em dia! Nenhuma notifica\xE7\xE3o n\xE3o lida." : "Sem notifica\xE7\xF5es.";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="text-2xl">🎉</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== message) {
    t3 = <div className="flex flex-col items-center gap-2 px-5 py-8 text-center">{t2}<span className="text-subtext-color text-[13.5px]">{message}</span></div>;
    $[1] = message;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}